import React from "react";
import { Rate } from "antd";
import Card from "components/card";

const BulletList = ({ items = [], gradient, itemFld=null }) =>
  items.map((item, idx) => (
    <div key={idx} className="flex items-center gap-2 py-1">
      <div
        className={`w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 bg-gradient-to-r ${gradient}`}
      >
        <div className="w-2 h-2 rounded-full bg-white"></div>
      </div>
      <p className="text-base text-gray-700">{itemFld ? item[itemFld] : item}</p>
    </div>
  ));

const ScoreCardItem = ({scoreItem}) => {
    return (
        <div className="flex flex-col gap-4">
            <Card className="flex flex-col rounded-2xl shadow-sm bg-white border-2 border-emerald-200">
                <div className="bg-gradient-to-br from-emerald-50 to-cyan-50 border-b rounded-t-2xl p-3 grid items-start">
                    <h4 className="text-[18px]">Matches</h4>
                </div>
                <div className="p-6">
                    <BulletList items={scoreItem?.matches} gradient="from-purple-500 to-emerald-500" />
                </div>
            </Card>
            <Card className="flex flex-col rounded-2xl shadow-sm bg-white border-2 border-blue-200">
                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border-b rounded-t-2xl p-3 grid items-start">
                    <h4 className="text-[18px]">Evidence</h4>
                </div>
                <div className="p-6">
                    <BulletList items={scoreItem?.evidence} gradient="from-purple-500 to-blue-500" itemFld="claim"/>
                </div>
            </Card>
            <Card className="flex flex-col rounded-2xl shadow-sm bg-white border-2 border-red-200">
                <div className="bg-gradient-to-br from-red-50 to-cyan-50 border-b rounded-t-2xl p-3 grid items-start">
                    <h4 className="text-[18px]">Gaps</h4>
                </div>
                <div className="p-6">
                    <BulletList items={scoreItem?.gaps} gradient="from-purple-500 to-red-500" />
                </div>
            </Card>
        </div>
    );
};

export default ScoreCardItem;
